import React from 'react';

const ContasReceberContext = React.createContext();

export default ContasReceberContext;
